import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useQueryClient } from "@tanstack/react-query";

export const useTagUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }) => {
      const res = await api.put(`/tags/update/${id}`, body ?? undefined);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["viewtags"]);
    },
  });
};

